import React from 'react';
import { Provider } from 'react-redux';
import store from './redux';

/*eslint-disable-next-line no-unused-vars*/
import i18n from './locales/i18n';

import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider, } from "react-router-dom";

import 'devextreme/dist/css/dx.light.css';
import "react-widgets/styles.css";
import 'semantic-ui-css/semantic.min.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import './index.css';

import TimeAgo from 'javascript-time-ago';
import fr from 'javascript-time-ago/locale/fr';

import moment from 'moment'
import 'moment/locale/fr';
import MomentLocalizer from 'react-widgets-moment';

import Config from './config/Config';

import routes from './routes';

moment.locale('fr');
new MomentLocalizer(moment);

TimeAgo.addDefaultLocale(fr)

const router = createBrowserRouter(routes, { basename: Config.basename });

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <RouterProvider router={router} store={store}/>
        </Provider>
    </React.StrictMode>
);
